import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const purchases = [{
  name: 'Sofía',
  country: 'Argentina'
}, {
  name: 'Carlos',
  country: 'México'
}, {
  name: 'Lucía',
  country: 'Colombia'
}, {
  name: 'Andrea',
  country: 'España'
}, {
  name: 'Valentina',
  country: 'Chile'
}, {
  name: 'Diego',
  country: 'Perú'
}, {
  name: 'Camila',
  country: 'Uruguay'
}, {
  name: 'María',
  country: 'Venezuela'
}, {
  name: 'Paula',
  country: 'Ecuador'
}, {
  name: 'Martín',
  country: 'Argentina'
}, {
  name: 'Isabella',
  country: 'República Dominicana'
}, {
  name: 'Fernanda',
  country: 'Costa Rica'
}, {
  name: 'Gabriela',
  country: 'Paraguay'
}, {
  name: 'Ricardo',
  country: 'Bolivia'
}, {
  name: 'Antonella',
  country: 'Argentina'
}];
export function PurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<(typeof purchases)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [timeAgo, setTimeAgo] = useState(1);
  useEffect(() => {
    const showPopup = () => {
      const randomPurchase = purchases[Math.floor(Math.random() * purchases.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1;
      setCurrentPurchase(randomPurchase);
      setTimeAgo(randomTime);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 3000);
    // Recurring interval (every 12 seconds)
    const intervalTimer = setInterval(showPopup, 12000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-221">
      {isVisible && currentPurchase && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 bg-white p-3 sm:p-4 rounded-xl shadow-2xl border border-gray-100 flex items-center gap-4 max-w-xs sm:max-w-sm" data-id="element-222">
          <img src="https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=100&h=100&fit=crop" alt="Product" className="w-12 h-12 sm:w-16 sm:h-16 rounded-lg object-cover shadow-sm" data-id="element-223" />
          <div className="flex-1 min-w-0" data-id="element-224">
            <p className="text-sm sm:text-base font-bold text-gray-900 truncate" data-id="element-225">
              ✅ {currentPurchase.name} de {currentPurchase.country}
            </p>
            <p className="text-xs sm:text-sm text-gray-600 truncate" data-id="element-226">
              compró Crecer Jugando
            </p>
            <p className="text-xs text-gray-400 mt-0.5" data-id="element-227">
              hace {timeAgo} {timeAgo === 1 ? 'minuto' : 'minutos'}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}